import { render, staticRenderFns } from "./UserExchangeCoupon.vue?vue&type=template&id=7bb45b45&scoped=true&"
import script from "./UserExchangeCoupon.vue?vue&type=script&lang=js&"
export * from "./UserExchangeCoupon.vue?vue&type=script&lang=js&"
import style0 from "./UserExchangeCoupon.vue?vue&type=style&index=0&id=7bb45b45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb45b45",
  null
  
)

export default component.exports